/**
Specifies file filter types.
*/
export enum ProjectFileFilterType {
  All = 'all',
  Content = 'content',
  Topic = 'topic',
  Snippet = 'snippet',
  TemplatePage = 'templatepage',
  Project = 'project',
  Toc = 'toc',
  Target = 'target',
  VariableSet = 'variableset',
  ConditionTagSet = 'conditiontagset',
  BrandingStylesheet = 'brandingstylesheet',
  Stylesheet = 'stylesheet',
  EditableFiles = 'editablefiles',
  Image = 'image',
  Multimedia = 'multimedia',
  Destination = 'destination',
  ProjectFile = 'projectfile',
}
